import { InvoiceSettingsParams } from "@jugl-web/rest-api";
import { TextInput } from "@jugl-web/ui-components/cross-platform";
import { useTranslations } from "@jugl-web/utils";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface CountryFieldProps {
  register: UseFormRegister<InvoiceSettingsParams>;
  errors: FieldErrors<InvoiceSettingsParams>;
  value: string;
}

const MAX_LENGTH = 100;

export const CountryField = ({
  register,
  errors,
  value,
}: CountryFieldProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <TextInput
        placeholder={t({
          id: "common.enter",
          defaultMessage: "Enter",
        })}
        {...register("country", {
          maxLength: {
            value: MAX_LENGTH,
            message: `${value.length}/${MAX_LENGTH}`,
          },
          setValueAs: (inputValue) => inputValue.trim(),
        })}
        isInvalid={!!errors.country}
        label={t({
          id: "invoices.settings.businessInformation.country",
          defaultMessage: "Country",
        })}
        errorMessage={errors.country?.message}
      />
    </div>
  );
};
